function initSliderProgress($carousel, selector) {
  var flkty = $carousel.data('flickity');
  if (!flkty || flkty.slides.length < 2) return;
  var container = document.querySelector(selector);
  if (!container) return;

  // Remove existing progress bar
  var existing = container.parentNode.querySelector('.slider-progress');
  if (existing) existing.remove();

  // Progress bar
  var progressEl = document.createElement('div');
  progressEl.className = 'slider-progress';
  progressEl.innerHTML = '<div class="slider-progress__bar"></div>';
  container.parentNode.insertBefore(progressEl, container.nextSibling);

  var bar = progressEl.querySelector('.slider-progress__bar');
  var count = flkty.slides.length;
  bar.style.width = (100 / count) + '%';

  function updateProgress() {
    bar.style.transform = 'translateX(' + (flkty.selectedIndex * 100) + '%)';
  }
  updateProgress();

  $carousel.on('select.flickity', updateProgress);

  // Limit swipe to one cell at a time (mobile only)
  if ($(window).width() < 651) {
    var dragStartIndex = 0;
    $carousel.on('dragStart.flickity', function() {
      dragStartIndex = flkty.selectedIndex;
    });
    $carousel.on('dragEnd.flickity', function() {
      var diff = flkty.selectedIndex - dragStartIndex;
      if (Math.abs(diff) > 1) {
        var target = dragStartIndex + (diff > 0 ? 1 : -1);
        target = Math.max(0, Math.min(flkty.slides.length - 1, target));
        flkty.select(target);
      }
    });
  }
}

function destroySlider(selector) {
  var $el = $(selector);
  if ($el.data('flickity')) {
    $el.flickity('destroy');
  }
  var container = document.querySelector(selector);
  if (container) {
    var bar = container.parentNode.querySelector('.slider-progress');
    if (bar) bar.remove();
  }
}

function productrecommendations(){
  destroySlider('.product-recommendations-slider');
  if ($(window).width() > 651) {
      var $product_carousel = $(".product-recommendations-slider").flickity({
        contain: true,
        wrapAround: true,
        freeScroll: false,
        groupCells: true,
        groupCells: 4,
        cellAlign: "left",
        prevNextButtons: true,
        pageDots: false,
      });
      initSliderProgress($product_carousel, '.product-recommendations-slider');
  }
  if ($(window).width() < 651) {
      var $product_carousel = $(".product-recommendations-slider").flickity({
        cellAlign: "left",
        contain: true,
        wrapAround: false,
        freeScroll: false,
        groupCells: 1,
        pageDots: false,
        prevNextButtons: false,
        friction: 0.5,
      });
      initSliderProgress($product_carousel, '.product-recommendations-slider');
  }
}

document.querySelectorAll('input[placeholder]').forEach(input => {
  if (input.placeholder?.toLowerCase().includes('eingeben')) {
    input.placeholder = input.placeholder.replace(/\s*eingeben\s*/gi, ' ').trim();
  }
});


function recentlyviewslider(){
  destroySlider('.recently_view_slider');
  if ($(window).width() > 651) {
      var $recently_product_carousel = $(".recently_view_slider").flickity({
        contain: true,
        wrapAround: true,
        freeScroll: false,
        groupCells: true,
        groupCells: 4,
        cellAlign: "left",
        prevNextButtons: true,
        pageDots: false,
      });
      initSliderProgress($recently_product_carousel, '.recently_view_slider');
  }
  if ($(window).width() < 651) {
      var $recently_product_carousel = $(".recently_view_slider").flickity({
        cellAlign: "left",
        contain: true,
        wrapAround: false,
        freeScroll: false,
        groupCells: 1,
        pageDots: false,
        prevNextButtons: false,
        friction: 0.5,
      });
      initSliderProgress($recently_product_carousel, '.recently_view_slider');
  }
}

// Re-init sliders on resize (debounced, only when width changes — iOS Safari
// fires resize events when the address bar hides/shows during scroll)
var _sliderResizeTimer;
var _lastWindowWidth = $(window).width();
$(window).on('resize', function() {
  clearTimeout(_sliderResizeTimer);
  _sliderResizeTimer = setTimeout(function() {
    var currentWidth = $(window).width();
    if (currentWidth !== _lastWindowWidth) {
      _lastWindowWidth = currentWidth;
      if ($('.product-recommendations-slider').length) productrecommendations();
      if ($('.recently_view_slider').length) recentlyviewslider();
    }
  }, 300);
});

$(document).ready(function () {
  $("form.cust_store_form").submit(function () {
    $(this).addClass("success_submit");
  });
  $("form .btn--close-search").click(function () {
    $(".search__input").val(null);
  });
  $(".nav-account-popup_btn").on("click", function () {
    $(".custom-model-main").addClass("model-open");
  });
  $(".close-btn, .bg-overlay").click(function () {
    $(".custom-model-main").removeClass("model-open");
  });

  $(".custom-btn-paypal").click(function (e) {
    e.preventDefault();
    var IDGET = $(this).attr("data-ids");
    IDGET = parseInt(IDGET);
    var QuantGET = $(this).attr("data-quant");
    QuantGET = parseInt(QuantGET);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: "quantity=" + QuantGET + "&id=" + IDGET,
      dataType: "json",
      success: function (line_item) {
        window.location.href = "/checkout";
      },
    });
  });
  // $("#CartDrawerForm .cart__checkout-wrapper .cart__checkout").click(function(e){
  //   e.preventDefault();
  //    window.location.href = "/cart";
  // });
  $(".changeproprty").change(function () {
    var SlectedValue = $(this).val();
    if (SlectedValue == 0) {
      $("#CustomNumberPoprty").val("");
    } else {
      $("#CustomNumberPoprty").val(SlectedValue);
    }
  });
  $(".CustomQuantity").change(function () {
    var SlectedValue = $(this).val();
    $(".custom-btn-paypal").attr("data-quant", SlectedValue);
    $(".js-qty__num").val(SlectedValue);
  });
  if (document.body.clientWidth < 992) {
    $(".header__location").insertAfter("#SiteHeader");
  } else {
    $(".header__location").insertAfter(".site-header__logo");
  }
  // if (document.body.clientWidth < 769) {
  //   $(".header-item.header-item--left").insertBefore(
  //     ".header-item.header-item--logo"
  //   );
  //   $(".billing-content-wrapper p").insertBefore(".billing-image-wrapper");
  //   // $(".G-translate_selector_add").insertAfter(".mobile-nav");
  // } else {
  //   $(".header-item.header-item--left").insertAfter(
  //     ".header-item.header-item--logo"
  //   );
  //   $(".billing-page-content p").insertBefore(".billing-content-wrapper form");
  // }

  $(".site-nav__link_account").on("mouseenter", function () {
    $(".nav-account-popup").addClass("active");
  });
  $(".site-nav__link_account").on("mouseleave", function () {
    $(".nav-account-popup").removeClass("active");
  });
  $(".nav-account-popup_close").on("click", function () {
    $(".nav-account-popup").removeClass("active");
  });
  $(".register_name_drop svg").on("click", function () {
    $(".register_name_drop_value").addClass("active");
  });

  // console.log( $('#titel').val());
  // $('input[name="contact[first_name]"]').val( $('#titel').val());
  //    $("#titel").change(function() {
  //     // console.log( $(this).val());
  //      $('input[name="contact[first_name]"]').val( $(this).val());
  //  });

  //  $( ".register_name_drop_value.active span" ).on( "click", function() {
  //   console.log($(this).attr('value'))
  //   $( ".register_name_drop_value span" ).removeClass('active');
  //    $(this).addClass('active');
  //   $( ".register_name_drop_value" ).removeClass("active");
  //    $('input[name="contact[first_name]"]').val($(this).attr('value'));
  // });

  var manuselect = document.querySelectorAll(".register_name_drop_value span");
  manuselect.forEach((b) => {
    b.addEventListener("click", function (event) {
      event.preventDefault();
      document
        .querySelector(".register_name_drop_value span")
        .classList.remove("active");
      this.classList.add("active");
      // console.log(this.dataset.value);
      document.querySelector('input[name="customer[first_name]"]').value =
        this.dataset.value;
      document
        .querySelector(".register_name_drop_value.active")
        .classList.remove("active");
    });
  });

  $("#FirstName")
    .focus(function () {
      $(".register_name_drop_value").addClass("active");
    })
    .blur(function () {
      // $(".register_name_drop_value").removeClass('active');
    });

  $("#FirstName").on("change keyup paste", function () {
    $(".register_name_drop_value").removeClass("active");
  });

  if (document.body.clientWidth < 651) {
    var $service_block = $(".service-block").flickity({
      contain: true,
      wrapAround: false,
      cellAlign: "left",
      prevNextButtons: false,
      pageDots: true,
    });

    var $service_block = $(".product-service-block").flickity({
      contain: true,
      wrapAround: true,
      cellAlign: "center",
      prevNextButtons: false,
      pageDots: true,
    });
  }


  
  var $product_carousel = $(".product_slider").flickityResponsive({
    contain: true,
    wrapAround: true,
    freeScroll: false,
    groupCells: 4,
    cellAlign: "left",
    prevNextButtons: true,
    pageDots: true,
    responsive: [
      {
        breakpoint: 651,
        settings: {
          cellAlign: "center",
          groupCells: true,
          groupCells: 1,
          pageDots: true,
        },
      },
    ],
  });

  

  const accordionBtns = document.querySelectorAll(".accordion");

  accordionBtns.forEach((accordion) => {
    accordion.onclick = function () {
      if( $(this).hasClass("is-open")){
        $(this).removeClass("is-open");
        this.nextElementSibling.style.maxHeight = "0px";
      }else{
      $(".accordion").removeClass("is-open");
      $(".accordion-content").css("max-height", "0px");
      $(this).addClass("is-open");
      let content = this.nextElementSibling;
      content.style.maxHeight = content.scrollHeight + "px";
      }
    

      
      // this.classList.toggle("is-open");
      //   console.log("testing==" + content.style.maxHeight);
      //   if (content.style.maxHeight == "" || content.style.maxHeight == "0px") {
      //     content.style.maxHeight = content.scrollHeight + "px";
      //   } else {
      //     content.style.maxHeight = null;
      //   }
      //   if (content.style.maxHeight) {
      //   } else {
      //   }
      //   $(this)
      //     .parent(".index-faq")
      //     .siblings(".index-faq")
      //     .children(".accordion")
      //     .removeClass("is-open");
      //   $(this)
      //     .parent(".index-faq")
      //     .siblings(".index-faq")
      //     .children(".accordion-content")
      //     .css("max-height", "0px");
      //   //


      
    };
  });
  $(document).on("click", "a[cart-quty-update]", function () {
    let updates = {};
    $(".js-qty__num.cust_update").each(function () {
      updates[[$(this).data("product_id")]] = $(this).attr("max");
    });

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally((e) => {
        document.addEventListener("ajaxProduct:added", function (evt) {
          console.log(evt.detail.product);
        });
        document.dispatchEvent(new CustomEvent("cart:build"));
      });
  });

  // Login/Register Password hide show js
  $(".show_pass").on("click", function () {
    var passInput = $(".hs_pass");
    if (passInput.attr("type") === "password") {
      passInput.attr("type", "text");
      $(".show_pass").addClass("active_pass");
    } else {
      passInput.attr("type", "password");
      $(".show_pass").removeClass("active_pass");
    }
  });

  var maxHeight = 0;
  $(".product_slider .grid-product").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });
  $(".product_slider .grid-product").height(maxHeight);
});


/* Removed: handleStickyByButtonPosition scroll handler.
   The CSS rule for body.sticky-add-tocart-button in dynamic.css.liquid is commented out,
   so this handler was dead code causing layout thrashing on every scroll frame (iOS flicker).
   If sticky add-to-cart is re-enabled, reintroduce with requestAnimationFrame throttling. */






